export const fmtEur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const fmtEur2 = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "short", year: "numeric" })
      .format(new Date(iso));
  } catch { return iso; }
};

export const relDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = Math.round((d - new Date()) / (1000 * 60 * 60 * 24));
  const rtf = new Intl.RelativeTimeFormat("it-IT", { numeric: "auto" });
  return rtf.format(diff, "day");
};

export const statusLabel = {
  in_corso: "In corso",
  in_pausa: "In pausa",
  completato: "Completato",
  annullato: "Chiuso",
  bozza: "Bozza",
  inviata: "Inviata",
  pagata: "Pagata",
  scaduta: "Scaduta",
  attivo: "Attivo",
  prospect: "Prospect",
  inattivo: "Inattivo",
  archiviato: "Inattivo",
};

export const statusColor = {
  in_corso: "bg-zen-info/20 text-zen-ink",
  in_pausa: "bg-zen-subtle/50 text-zen-ink",
  completato: "bg-zen-primary/15 text-zen-primary",
  annullato: "bg-zen-alert/20 text-zen-alert",
  bozza: "bg-zen-border text-zen-ink2",
  inviata: "bg-zen-info/20 text-zen-ink",
  pagata: "bg-zen-primary/15 text-zen-primary",
  scaduta: "bg-zen-alert/20 text-zen-alert",
  attivo: "bg-zen-primary/15 text-zen-primary",
  prospect: "bg-zen-info/20 text-zen-ink",
  inattivo: "bg-zen-border text-zen-ink2",
  archiviato: "bg-zen-border text-zen-ink2",
};
